module.exports = __webpack_public_path__ + "img/banner.bdcb1e46.png";